<template lang="pug">
  #login
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      HeaderForLogin
      b-container.login-container.text-center.pt-5(fluid)
        b-row.min-width-box(:no-gutters="true")
          b-col.w-50
            img.back-image(src="@/assets/images/bg-img.png")
          b-col.w-50.ml-1
            b-card.mx-auto.login-box(body-class="px-5")
              div(v-if="error_msg_list.length > 0" data-testid="login_errors")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list") {{error_msg}}
              b-form(@submit.prevent="login()")
                b-form-group.mt-4
                  b-container
                    b-row
                      b-col
                        b-form-input.mt-1(v-model="sub_domain.value", required, placeholder="サブドメイン名", data-testid="input_domain_name", :state="sub_domain.error_msg_list.length === 0 ? null : false")
                      b-col
                        b-form-radio-group.radio-align-left.domain-name-font-size(v-model="sub_domain_radio.value", :checked="sub_domain_radio.options[0].value", :state="sub_domain_radio.error_msg_list.length === 0 ? null : false")
                          b-form-radio(:value="sub_domain_radio.options[0].value") {{sub_domain_radio.options[0].name}}
                          b-form-radio(:value="sub_domain_radio.options[1].value") {{sub_domain_radio.options[1].name}}
                  b-form-text.align-left.text-left.error-message-color(v-for="(message) of sub_domain.error_msg_list") {{message}}
                  b-form-text.align-left.text-left.error-message-color(v-for="(message) of sub_domain_radio.error_msg_list") {{message}}
                  sub-domain-tool-tips.text-left
                b-form-group.mt-2
                  b-form-input.mt-1(v-model="mail.value", required, placeholder="メールアドレス", data-testid="input_mail_address", :state="mail.error_msg_list.length === 0 ? null : false")
                  b-form-text.align-left.text-left.error-message-color(v-for="(message) of mail.error_msg_list") {{message}}
                b-form-group.mt-2
                  b-form-input.mt-1(v-model="pwd", required, type="password", placeholder="パスワード", data-testid="input_password")
                b-form-checkbox.login-check-box.text-left(v-model="save_check.checked") {{save_check.label}}
                b-button.w-100.mt-4.mb-3(type="submit", variant="primary" data-testid="btn_login", :disabled="isLoginButtonDisabled") ログイン
              router-link.text-left(:to="{name: 'OrderNewAccount'}") クラウド版サポートサイトのアカウントを持っていない方はこちら
              b-form-group(style="height: 10px")
              router-link.text-left(:to="{name: 'ResetPassword'}") パスワードを忘れた方はこちら
</template>

<script>
import Api from '@/repositories/api'
import Loading from "@/components/Loading";
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";
import SubDomainToolTips from "@/components/supportSite/SubDomainToolTips";

const LoginRepository = Api.get('c201Login')

export default {
  /* eslint-disable */
  name: "Login.vue",
  components: {
    Loading,
    HeaderForLogin,
    SubDomainToolTips
  },
  data() {
    return {
      sub_domain: {
        value: "",
        error_msg_list: []
      },
      mail: {
        value: "",
        error_msg_list: []
      },
      pwd: "",
      sub_domain_radio: {
        value: "0",
        options: [
          { value: "0", name: ".dn-cloud.com" },
          { value: "1", name: ".chatluck.net" }
        ],
        error_msg_list: []
      },

      save_check: {
        checked: false,
        label: "この情報をブラウザーに保存する。"
      },

      error_msg_list: [],

      // ログインボタンフラグ
      isLoginButtonDisabled: false,

      // 読み込み中フラグ
      isLoading: false,
    }
  },
  created() {
    // 読み込み中
    this.isLoading = true;

    // ログイン済チェック処理
    LoginRepository.check()
    .then((response) => {
      // 既にログインしている場合
      if (response.data.data.is_login === true) {
        // トップページへ遷移する
        this.$router.push({name: "TopPage"})
      }
    })
    .finally(() => [
        // 読み込み完了
        this.isLoading = false
    ])

    // 入力欄にデータを書き込む処理
    let domain, mail, password, sub_domain_radio;
    // localStageから情報を取得する
    domain = localStorage.getItem('sub_domain');
    mail   = localStorage.getItem('mail');
    password = localStorage.getItem('password');
    sub_domain_radio = localStorage.getItem('sub_domain_radio')
    // localstrageに情報があったら
    if(domain !== null && mail !== null && password !== null && sub_domain_radio !== null) {
      // 入力欄に情報を書き込む
      this.sub_domain.value       = domain;            // サブドメイン名
      this.mail.value             = mail;              // メールアドレス
      this.pwd                    = password;          // パスワード
      this.sub_domain_radio.value = sub_domain_radio;  // ラジオボタン
    }
  },
  methods: {
    login() {
      // エラーメッセージを初期化する
      this.error_msg_list = []
      this.sub_domain.error_msg_list = [];
      this.mail.error_msg_list = [];
      this.sub_domain_radio.error_msg_list = [];

      // ログインボタンをロックする
      this.isLoginButtonDisabled = true;

      // リクエストデータの生成
      const params = new URLSearchParams()
      params.append('mail', this.mail.value)
      params.append('password', this.pwd)
      params.append('sub_domain', this.sub_domain.value)
      params.append('sub_domain_radio', this.sub_domain_radio.value)

      // ログインコード（メールアドレス:サブドメイン名）を作成する
      const subdomain = this.sub_domain_radio.options.find((element) => element.value === this.sub_domain_radio.value)
      // ※サブドメイン名は小文字に変換する
      params.append('login_cd', this.mail.value + ':' + this.sub_domain.value.toLowerCase() + (subdomain ? subdomain.name : ''))

      // ログイン処理
      LoginRepository.login(params)
        .then(() => {
          // localstrageに入力データを保存する
          // ブラウザに情報を保存するにチェックされていたら
          if (this.save_check.checked === true) {
            // ドメイン、メール、パスワード情報を保存する
            localStorage.setItem('sub_domain', this.sub_domain.value)             // サブドメイン名
            localStorage.setItem('mail', this.mail.value)                         // メールアドレス
            localStorage.setItem('password', this.pwd)                            // パスワード
            localStorage.setItem('sub_domain_radio', this.sub_domain_radio.value) // ラジオボタン
          }

          // cookieにログイン画面の種類（'0':通常ログイン）のフラグをセットする
          this.setCookieOfLoginType('0')

          // トップページへ遷移する
          this.$router.push({name: "TopPage"})
        })
        .catch((error) => {
          // ログインボタンのロックを解除する
           this.isLoginButtonDisabled = false;

          // 共通のエラー処理
          this.apiError(error, 'ログイン処理')

          // 認証失敗時の場合
          if (error.response.data.message) {
            this.error_msg_list.push(error.response.data.message)
          }
          // それ以外の場合
          else {
            for (let errorData of error.response.data.error_list) {
              // 入力エラーではない場合
              if (!errorData.target) {
                this.error_msg_list.push(errorData.error_msg)
                continue
              }
              // 入力エラー
              this[errorData.target].error_msg_list.push(errorData.error_msg)
            }
          }

          // パスワードを空にする
          this.pwd = ''
        })
    }
  }
}
</script>

<style scoped>
.login-container {
  max-width: 1200px;
}
.login-box {
  width: 590px;
}
.back-image {
  width: 570px;
}
.white-space {
  white-space: pre-wrap;
}
.login-check-box {
  z-index: 0;
}
</style>